import React from 'react'
import Container from 'react-bootstrap/Container';
import { useTranslation } from 'react-i18next';
import { useCuttingPlanStatsStore } from '../../../../stores/cuttingPlanStatsStore';

const Statistics = () => {
    const { i18n, t } = useTranslation();

    const cuttingPlanStats = useCuttingPlanStatsStore(state => state.cuttingPlanStats);

    const fontSize = "0.8em";
    return (
        <Container className='m-0 p-0' style={{ maxHeight: '675px', overflowY: 'auto' }}>
            <div className="table-responsive">
                <table className="table table-bordered table-striped-columns">
                    <tbody>
                        <tr>
                            <th style={{ width: "63%", fontSize: fontSize }}>{t("Terorik Ağırlık")} (kg)</th>
                            <td style={{ width: "37%" }}>{cuttingPlanStats.theoreticalWeight}</td>
                        </tr>
                        <tr>
                            <th style={{ width: "63%", fontSize: fontSize }}>{t("Toplam")} (kg)</th>
                            <td style={{ width: "37%" }}>{cuttingPlanStats.totalWeight}</td>
                        </tr>
                        <tr>
                            <th style={{ fontSize: fontSize }}>{t("Toplam Boy Sayısı")}</th>
                            <td>{cuttingPlanStats.totalLogs}</td>
                        </tr>
                        <tr>
                            <th style={{ fontSize: fontSize }}>{t("Teorik Fire")} (kg)</th>
                            <td>{cuttingPlanStats.totalWasteWeight}</td>
                        </tr>
                        <tr className="d-md-table-row d-none">
                            <th style={{ fontSize: fontSize }}>{t("Sipariş")} (kg)</th>
                            <td>{cuttingPlanStats.orderWeight}</td>
                        </tr>
                        <tr className="d-md-table-row d-none">
                            <th style={{ fontSize: fontSize }}>{t("Sipariş (Kesimli Hariç)")} (kg)</th>
                            <td>{cuttingPlanStats.orderWeightExceptPreCut}</td>
                        </tr>
                        <tr>
                            <th style={{ fontSize: fontSize }}>{t("Sipariş Boy Sayısı")}</th>
                            <td>{cuttingPlanStats.orderLogs}</td>
                        </tr>
                        <tr className="d-md-table-row d-none">
                            <th style={{ fontSize: fontSize }}>{t("Elde Kalan Fire")} (kg)</th>
                            <td>{cuttingPlanStats.outageWeight}</td>
                        </tr>
                        <tr className="d-md-table-row d-none">
                            <th style={{ fontSize: fontSize }}>{t("Hazır Kesimli Donatı")} (kg)</th>
                            <td>{cuttingPlanStats.preCutWeight}</td>
                        </tr>
                        <tr className="d-md-table-row d-none">
                            <th style={{ fontSize: fontSize }}>{t("Yerine Kullanım")} (kg)</th>
                            <td>{cuttingPlanStats.subWeight}</td>
                        </tr>
                        <tr className="d-md-table-row d-none">
                            <th style={{ fontSize: fontSize }}>{t("Verim")} (%)</th>
                            <td>{cuttingPlanStats.yieldPercentage}</td>
                        </tr>
                        <tr className="d-md-table-row d-none">
                            <th style={{ fontSize: fontSize }}>{t("Verim (Kesimli Hariç)")} (%)</th>
                            <td>{cuttingPlanStats.yieldExceptPreCutPercentage}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </Container>
    )
}

export default Statistics;